import { render, staticRenderFns } from "./storeValue-info.vue?vue&type=template&id=922acd3a"
import script from "./storeValue-info.vue?vue&type=script&lang=js"
export * from "./storeValue-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports